import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../HeaderSection/Header';
import Breadcrumb from '../Blogs/Breadcrumb';
import FaqSection from '../FaqSection/FaqOne'
import DownloadSection from '../DownloadSection/Download';
import ContactSection from '../ContactSection/Contact';
import FooterSection from '../FooterSection/Footer';
import Navbar from '../Navbar/Navbar';
import logo from "../../assets/logo.png";
class Faq extends Component {
    render() {
        return (
            <div id="faq">
                {/*====== Scroll To Top Area Start ======*/}
                <div id="scrollUp" title="Scroll To Top">
                    <i className="fas fa-arrow-up" />
                </div>
                {/*====== Scroll To Top Area End ======*/}
                <div className="main">
                    <Helmet>
                        <title>FAQ | MoneyMonk - Frequently Asked Questions</title>
                        <meta name="description" content="Find answers to frequently asked questions about MoneyMonk personal loans, eligibility, repayment, and the digital loan application process." />
                        <link rel="canonical" href="https://moneymonkapp.in/faq" />
                    </Helmet>
                    {/* <Header imageData={"/img/logo-white.png"} /> */}
                    <Navbar imageData={logo} />
                    {/* <Breadcrumb title="FAQ" /> */}
                    <FaqSection />
                    <DownloadSection />
                    <ContactSection />
                    <FooterSection />
                </div>
            </div>
        );
    }
}

export default Faq;